
export default function useList(listName: string) {
  switch (listName) {
    case "CaseStatus"    : return ["Intake", "Seeking Treatment", "Ordering Records", "Demand in Process", 
      "In Negotiation", "Final Settlement", "Closed"]
    case "IntakeStatus"  : return ["Lead", "Opened", "Processing", "On Hold", "Case Created"]
    case "AssociatedAttorney": return ["Vincent Williams", "Anthony Baxter"]
    case "CaseManager"   : return ["Jessica Swan", "Madeline Mycon", "Dakota Bueing", "Karla Otterbech"]
    case "ReferralSource": return ["Referral", "Helpline", "Online", "Social Media", "Radio", "TV", "Direct Mail", "Other"]
    case "CaseActivity": return [
      "Note",
      "Contact", 
      "Fee Agreement Sent", 
      "Fee Agreement Received", 
      "Police Report Received", 
      "Damage Photos Received", 
      "Medical Authorization Signed", 
      "Intakes Completed", 
      "Completed Treatment", 
      "Confirmation of Treatment", 
      "Records Ordered", 
      "Records Received", 
      "VIS Completed", 
      "Statement of Exhibits", 
      "Demand Sent", 
      "Negotiation Call",
      "Case Filed",
      "Case Settled",
      "Check Received",
      "Final Accounting Signed", 
      "Hold Harmless Signed"]
    case "LitigationActivity": return ["Note", "Contact", "Summons and Complaint Drafted", "Summons and Complaint Filed", "Sent to Adjuster","Process Service Ordered", "Process Service Failed", "Defendant Served", "Process Service Ordered by Mail", "Proof of Service Filed", "Notice of Appearance Filed", "Notice of Appearance Received", "Interrogatories Received from Opposing", "Opposing's Interrogatories Emailed to Client", "Completed Interrogatories Received", "Interrogatories Submitted to Opposing", "Request for Production Received", "Request for Production Completed", "Request for Production Submitted to Opposing", "Deposition Completed", "Expert Witness List Completed", "Expert Witness List Submitted", "File Motion to Dismiss", "File Motion for Summary Judgement", "File Motion to Compel Discovery", "File Statement of Arbitrability", "De Novo Decision", "Confirmation of Joinder Filed", "ER 904 Submission filed", "Date of Judgment", "Case Appealed", "Final Settlement and Collection Date"]
    case "UserActivity": return ["Note", "Contact", "Administration", "Other"]
    case "CostCategory": return ["Records", "Mailings", "Legal Fees", "Police Report", "Misc"]
  }

  return []
}

export function CaseActivity() {
  return [
    { name: "Fee Agreement Sent", await: "We will send a Fee Agreement shortly", done: "We have sent you a Fee Agreement to sign. Please check your email.", 
      remind:  3, warn:   6, since: "Case Created" },
    { name: "Fee Agreement Received", await: "Awaiting signed Fee Agreement.", done: "We have received your signed Fee Agreement.", 
      remind: 10, warn:  15, since: "Fee Agreement Sent" },
    { name: "Police Report Received", await: "Police Report pending", done: "Police Report received", 
      remind: 30, warn:  60, since: "Case Created" },
    { name: "Damage Photos Received", await: "Awaiting damage photos.", done: "We have damage photos filed.", 
      remind: 30, warn:  60, since: "Case Created" },
    { name: "Medical Authorization Signed", await: "Awaiting signed Medical Authorization.", done: "We have received your signed Medical Authorization.", 
      remind:  3, warn:   6, since: "Fee Agreement Received" },
    { name: "Intakes Completed", await: "Awaiting completion of intakes.", done: "Intakes have been completed.", 
      remind: 30, warn:  60, since: "Case Created" },
    { name: "Completed Treatment", await: "Awaiting confirmation of treatment completion.", done: "Treatment has been completed.", 
      remind: 90, warn: 180, since: "Fee Agreement Sent" },
    { name: "Confirmation of Treatment", await: "Awaiting confirmation of treatment.", done: "Treatment has been confirmed.", 
      remind:  7, warn:  14, since: "Completed Treatment" },
    { name: "Records Ordered", await: "Awaiting ordered records.", done: "Records have been ordered.", 
      remind:  7, warn:   14, since: "Confirmation of Treatment" },
    { name: "Records Received", await: "Records pending", done: "We have received the requested records.", 
      remind: 30, warn:  60, since: "Records Ordered" },
    { name: "VIS Completed", await: "VIS not written.", done: "VIS has been completed.", 
      remind: 30, warn:  60, since: "Confirmation of Treatment" },
    { name: "Statement of Exhibits", await: "Statement of Exhibits not written.", done: "Statement of Exhibits has been completed.", 
      remind:  3, warn:   6, since: "Confirmation of Treatment" },
    { name: "Demand Sent", await: "", done: "We have sent a Demand letter to the responsible party.", 
      remind: 90, warn: 120, since: "Records Ordered" },
    { name: "Negotiation Call", await: "Negotiation have not started", done: "Negotiations are in progress.", 
      remind: 15, warn:  30, since: "Demand Sent" },
    { name: "Case Settled", await: "Case has not been settled yet.", done: "Case has been settled.", 
      remind: 60, warn:  90, since: "Demand Sent" },
    { name: "Check Received", await: "Settlement check is still pending.", done: "We have received the settlement check.", 
      remind: 10, warn:  15, since: "Case Settled" },
    { name: "Final Accounting Signed", await: "Final accounting pending.", done: "Final accounting has been signed.", 
      remind: 30, warn:  45, since: "Check Received" },
    { name: "Hold Harmless Signed", await: "Hold Harmless pending.", done: "Hold Harmless has been signed.", 
      remind:  3, warn:   6, since: "Demand Sent" }
  ]
}
